

app.controller('LoginCtrl', function ($scope, uibDateParser, $http, $window, $location, $timeout, Upload, $q, $uibModal) {
    $scope.user = {
        Email: ''
    };
    

    var allPromise = $q.all([

        $http({
            method: 'GET',
            url: '/service/client.svc/SignOut',
        }).then(function (data) {
        }, function (error) { })
    ]);

    $scope.working = false;
    $scope.loadMessage = 'Loading...';

    $scope.after_login = {};

    $scope.openModalOTP = function () {
        let tempMessage = {
            Email: $scope.user.Email
        };
        var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: 'myModalOTP.html',
            controller: 'ModalOTPCtrl',
            size: 'md',
            resolve: {
                items: function () {
                    return tempMessage;
                }
            }
        });
    };

    $scope.submit = function () {
        $scope.working = true;

        //ecnrypt email
        var key = CryptoJS.enc.Utf8.parse('123456789qwertyu'); // Panjang 16 byte untuk AES-128
        var iv = CryptoJS.enc.Utf8.parse('qwerty0987654321'); // Juga 16 byte

        var plaintext = $scope.user.Email;

        var encrypted = CryptoJS.AES.encrypt(plaintext, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });

        $http({
            method: 'POST',
            url: '/service/client.svc/ResendOTP',
            data: {
                email: encrypted.toString(),

            },
        }).then(function (data) {
            $scope.working = false;
            $scope.result = data.data.d;
            console.log('res', $scope.result);

            if ($scope.result) {
                $scope.openModalOTP();
            }

       
        },
        function (error) {

        });
    };


    allPromise.then(function () {

    });


});

app.controller('ModalOTPCtrl', function ($scope, $window, $rootScope, $uibModalInstance, $uibModal, $q, deviceDetector, items, $http, $interval) {

        $scope.user = {};

        $scope.items = items;

        $scope.ok = function () {
            $uibModalInstance.close($scope.items);
        };
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.verif = function (index, event) {
            if ($scope.code1 && $scope.code2 && $scope.code3 && $scope.code4 && $scope.code5 && $scope.code6)
                console.log('done1')
            else {
                if (index && ((event.keyCode >= 65 && event.keyCode <= 90) || (event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105))) {
                    let focusCtrl = "#verif" + (index + 1);
                    angular.element(focusCtrl).focus();
                }
            }
        }

        $scope.processCb = function (event) {
            let data = event.originalEvent.clipboardData.getData('text/plain');
            if (data.length == 4) {
                $scope.code1 = data[0];
                $scope.code2 = data[1];
                $scope.code3 = data[2];
                $scope.code4 = data[3];
                $scope.code5 = data[5];
                $scope.code6 = data[6];

            }
        }

        $scope.verFocus = function (index) {
            if ($scope.code1 && $scope.code2 && $scope.code3 && $scope.code4)
                console.log('done2')
            else {
                switch (index) {
                    case 1: $scope.code1 = ''; break;
                    case 2: $scope.code2 = ''; break;
                    case 3: $scope.code3 = ''; break;
                    case 4: $scope.code4 = ''; break;
                    case 5: $scope.code5 = ''; break;
                    case 6: $scope.code6 = ''; break;
                }
            }
        }

        $scope.otp = new Array(8).fill('');
        $scope.timeLeft = 300;
        var countdown;

    // Fungsi mulai countdown
        $scope.startCountdown = function () {
            if (countdown) $interval.cancel(countdown);
            $scope.timeLeft = 300;

            countdown = $interval(function () {
                if ($scope.timeLeft > 0) {
                    $scope.timeLeft--;
                } else {
                    $interval.cancel(countdown);
                }
            }, 1000);
        };


    // Fungsi kirim ulang OTP
        $scope.resendOTP = function () {
            swal({
                title: 'OTP Baru Dikirim!',
                text: 'Silakan cek pesan Anda untuk kode OTP terbaru.',
                icon: 'success',
                confirmButtonColor: '#dc3545',
                confirmButtonText: 'OK'
            });
            $scope.startCountdown();
        };


    // Jalankan countdown pertama kali
        $scope.startCountdown();


        $scope.submitOTP = function () {
            var data = {
                OTP: $scope.user.code1 + $scope.user.code2 + $scope.user.code3 + $scope.user.code4 + $scope.user.code5 + $scope.user.code6,
                Email: $scope.items.Email
            }
            $rootScope.AlertYesNo('question', 'Konfirmasi', "Apakah OTP Anda sudah sesuai ?")
            .then((result) => {
                if (result.value) {
                    $rootScope.AlertShowLoading('warning', 'Loading...', '', 0);
                    $http({
                        method: 'POST',
                        url: '/service/client.svc/LoginUser',
                        data:
                            {
                                UserLogin: data
                            },
                    }).then(function (data) {
                        $scope.result = data.data.d;

                        if ($scope.result.result) {
                            if ($scope.result.IsFinished == 1 || $scope.result.IsRevised == 1) {
                                $window.location.href = "#/dashboard";
                                $window.location.reload();
                            }

                            console.log("stage", $scope.result.Stage);

                            if ($scope.result.Stage) {

                                if ($scope.result.Stage == 1) {
                                    //$window.location.href = "#/cif/data-pribadi";
                                    if ($scope.result.IsFinished == 1 || $scope.result.IsRevised == 1) {
                                        $window.location.href = "#/dashboard";
                                        swal.close();
                                        $window.location.reload();
                                    }
                                    else {
                                        $window.location.href = "#/cif/data-pribadi";
                                        swal.close();
                                        $window.location.reload();
                                    }
                                }
                                if ($scope.result.Stage == 2) {
                                    $window.location.href = "#/cif/data-pekerjaan";
                                    swal.close();
                                    $window.location.reload();
                                }
                                if ($scope.result.Stage == 3) {
                                    $window.location.href = "#/cif/data-pekerjaan";
                                    swal.close();
                                    $window.location.reload();
                                }
                                if ($scope.result.Stage == 4) {
                                    if ($scope.result.IsFinished == 1) {
                                        $window.location.href = "#/dashboard";
                                        swal.close();
                                        $window.location.reload();
                                    } else {
                                        $window.location.href = "#/cif/data-pernyataan";
                                        swal.close();
                                        $window.location.reload();
                                    }

                                    if ($scope.result.IsRevised == 1) {
                                        $window.location.href = "#/dashboard";
                                        swal.close();
                                        $window.location.reload();
                                    }
                                }
                            }
                            else {
                                console.log('masuk')
                                if ($scope.result.Stage == 0) {
                                    console.log('a')
                                    $window.location.href = "#/preparation";
                                    swal.close();
                                    $window.location.reload();
                                }
                            }
                        }
                        else {
                            swal('Login Failed', $scope.result.message, 'error');
                        }
                    }, function (error) {
                        Swal.fire('Error', 'error - Please check your connection', 'error');
                    });
                }
            });

        }



    });
